import type { FC } from 'react';

import ExoticsCalculateBandContent from './exotics-calculate-band-content';
import type { ExoticsCalculateBandProps } from './types';

const ExoticsCalculateBandWidget: FC<ExoticsCalculateBandProps> = ({ instrumentId }) => (
  <ExoticsCalculateBandContent instrumentId={instrumentId} />
);

export default ExoticsCalculateBandWidget;
